import { applyStreamAspectToElement } from './streamAspect';
import {
  DEFAULT_STREAM_POSTER_SECONDS,
  isStreamPlayerHost,
  readMwAspectFromSrc,
  withStreamPoster,
} from './streamVideo';

function withPlaysinlineQuery(src: string) {
  try {
    const url = new URL(src, 'https://mousewait.com');
    url.searchParams.set('playsinline', 'true');
    return url.toString();
  } catch {
    return src.includes('playsinline=') ? src : `${src}${src.includes('?') ? '&' : '?'}playsinline=true`;
  }
}

export function ensureStreamPlayerIframes(html: string): string {
  if (!html || typeof DOMParser === 'undefined' || !html.includes('<iframe')) {
    return html;
  }

  const doc = new DOMParser().parseFromString(html, 'text/html');
  const iframes = Array.from(doc.querySelectorAll('iframe'));
  let changed = false;

  iframes.forEach((iframe) => {
    const src = iframe.getAttribute('src') || '';
    if (!isStreamPlayerHost(src)) {
      return;
    }

    // Posts saved before the frame picker have no poster; Stream's frame 0 is
    // often black, so give them the default frame.
    const withPlaysinline = withPlaysinlineQuery(src);
    let nextSrc = /[?&]poster=/.test(withPlaysinline)
      ? withPlaysinline
      : withStreamPoster(withPlaysinline, DEFAULT_STREAM_POSTER_SECONDS);
    try {
      const url = new URL(nextSrc);
      if (!url.searchParams.get('letterboxColor')) {
        url.searchParams.set('letterboxColor', 'transparent');
        nextSrc = url.toString();
      }
    } catch {
      // Keep the trusted src if it is not a valid URL.
    }
    if (iframe.getAttribute('src') !== nextSrc) {
      iframe.setAttribute('src', nextSrc);
      changed = true;
    }
    const size = readMwAspectFromSrc(nextSrc);
    if (size) {
      const beforeStyle = iframe.getAttribute('style') || '';
      const beforeOrientation = iframe.getAttribute('data-orientation') || '';
      applyStreamAspectToElement(iframe, size.width, size.height);
      if (
        (iframe.getAttribute('style') || '') !== beforeStyle ||
        (iframe.getAttribute('data-orientation') || '') !== beforeOrientation
      ) {
        changed = true;
      }
    }
    if (iframe.getAttribute('playsinline') !== 'true') {
      iframe.setAttribute('playsinline', 'true');
      changed = true;
    }
    if (iframe.getAttribute('webkit-playsinline') !== 'true') {
      iframe.setAttribute('webkit-playsinline', 'true');
      changed = true;
    }
    if (!iframe.classList.contains('ql-video')) {
      iframe.classList.add('ql-video');
      changed = true;
    }
    if (!iframe.classList.contains('mw-stream-video')) {
      iframe.classList.add('mw-stream-video');
      changed = true;
    }
    if (!iframe.getAttribute('allowfullscreen')) {
      iframe.setAttribute('allowfullscreen', 'true');
      changed = true;
    }
    if (!iframe.getAttribute('allow')) {
      iframe.setAttribute(
        'allow',
        'accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture; fullscreen'
      );
      changed = true;
    }
  });

  return changed ? doc.body.innerHTML : html;
}
